import React, { useState } from 'react'
import { navigate } from 'gatsby'
import { SEO, showMessage, ErrorAlert } from 'components/common'
import {
  DiscountCreateInput,
  useDiscountCreateMutation,
} from 'lib/graphql/storeadmin/types-and-hooks'
import { discountErrorHandling } from 'lib/hooks'
import { ShowDiscount } from 'components/discounts/form'
import { DiscountStatus } from '../../../lib/graphql/storeadmin/types-and-hooks'

export const Head = () => <SEO title="ディスカウントの作成" />

const IndexPage = (): JSX.Element => {
  const [createDiscount, { loading, error }] = useDiscountCreateMutation()

  const [showDiscountErrorAlert, setShowDiscountErrorAlert] = useState(false)
  const [discountErrorDescription, setDiscountErrorDescription] = useState([])

  const onSubmit = async (values: DiscountCreateInput) => {
    const status = DiscountStatus.Active
    try {
      const inputValue = {
        ...values,
        product: values.product?.['value'] ?? values.product,
        canOverlap: values.canOverlap['value'] ?? values.canOverlap,
        discountPercent:
          values.discountPercent['value'] ?? values.discountPercent,
        status,
      }

      const { data } = await createDiscount({
        variables: { input: inputValue },
      })

      const { discountCreate } = data
      const userErrors = discountCreate?.discountUserErrors || []

      if (userErrors.length > 0) {
        setShowDiscountErrorAlert(true)
        const errorMessages = discountErrorHandling(userErrors)
        setDiscountErrorDescription(errorMessages)
        setShowDiscountErrorAlert(true)
        showMessage('error', 'エラーが発生しました。')
      } else if (error) {
        setShowDiscountErrorAlert(true)
        showMessage('error', 'エラーが発生しました。')
      } else {
        setShowDiscountErrorAlert(false)
        showMessage('success', '新規ディスカウントを追加しました。')
        navigate(`../${data.discountCreate.discount.id}`)
      }
    } catch (e) {
      setShowDiscountErrorAlert(true)
      setDiscountErrorDescription([e.message])
      showMessage('error', 'サーバーとの通信時にエラーが発生しました。')
    }
  }

  const onCloseAlert = () => {
    setShowDiscountErrorAlert(false)
  }

  return (
    <>
      {showDiscountErrorAlert && (
        <ErrorAlert
          onCloseAlert={onCloseAlert}
          alertDescription={discountErrorDescription}
        />
      )}
      <ShowDiscount onSubmit={onSubmit} created={true} loading={loading} />
    </>
  )
}

export default IndexPage
